import React, { Component } from "react";
import Toast from '../components/Toast';
import TopMenu from "../components/TopMenu";
import AccountInfo from "../components/AccountInfo";

class AccountInfoLayout extends Component {

    render() {
        return (
            <div className="accountinfo-page">
                <TopMenu />
                <AccountInfo />
                <Toast />
            </div>
        );
    }
}

export default AccountInfoLayout;
